import request from '@/utils/request'
/* 权限管理首页-各会员的二级权限
** 地址： http://doc.pharmconverge.com/index.php?s=/22&page_id=584
*  说明 后端返回的是一个二维数据 根据下标 依次是： 普通 初级 中级 高级 SVIP会员
 */
export function memberPermissionList() {
  return request({
    url: '/member/sub_permission_list',
    method: 'get'
  })
}

/**
 * 根据会员等级编辑权限
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=586
 */
export function memberPermissionEdit(data) {
  return request({
    url: '/member/permission_edit_by_level',
    method: 'post',
    data: data
  })
}

/**
 * 获取会员的权限列表
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=585
 * 说明：参数 level 0: 普通 : 初级 ...
 */
export function permissionList(params) {
  return request({
    url: '/member/permission_list_by_level',
    method: 'get',
    params: params
  })
}

/**
 * 会员申请列表
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=589
 */
export function memberApplyList(params) {
  return request({
    url: '/member/apply_list',
    method: 'get',
    params: params
  })
}

/**
 * 会员申请标记已处理
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=590
 */
export function memberApplyMark(data) {
  return request({
    url: '/member/apply_mark',
    method: 'post',
    data: data
  })
}

/**
 * 查看一个小类下的url
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=587
 */
export function memberPermissionUrl(params) {
  return request({
    url: '/member/permission_url_by_type',
    method: 'get',
    params: params
  })
}

/**
 * 编辑一个子类的url
 * 地址： http://doc.pharmconverge.com/index.php?s=/22&page_id=588
 * 说明： url是一个字符串 半角逗号分割 url和备注 竖线分割每个 url
 */
export function memberEditUrl(data) {
  return request({
    url: '/member/permission_url_edit_by_type',
    method: 'post',
    data: data
  })
}
